import React, { useRef, useState } from 'react';
import { Pie } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';

ChartJS.register(ArcElement, Tooltip, Legend);

function DiversificationPieChart({ data }) {
  // We use a ref to get access to the chart instance for generating the legend
  const chartRef = useRef(null);
  // We use state to hold the HTML for our custom legend
  const [legendHtml, setLegendHtml] = useState(null);

  const chartData = {
    labels: data.map(d => d.sector),
    datasets: [{
      label: 'Value',
      data: data.map(d => d.value),
      backgroundColor: [
        '#4e73df', '#1cc88a', '#36b9cc', '#f6c23e', '#e74a3b', '#858796'
      ],
      hoverBackgroundColor: [
        '#2e59d9', '#17a673', '#2c9faf', '#f4b619', '#e02d1b', '#60616f'
      ],
      borderWidth: 1,
    }]
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      // We disable the default legend because we are creating our own.
      legend: {
        display: false
      },
      // We customize the tooltip to show percentages.
      tooltip: {
        backgroundColor: 'rgba(0, 0, 0, 0.8)',
        titleColor: '#fff',
        bodyColor: '#fff',
        callbacks: {
          label: function(context) {
            const label = context.label || '';
            const value = context.raw || 0;
            const total = context.chart.getDatasetMeta(0).total;
            const percentage = ((value / total) * 100).toFixed(1);
            return `${label}: ${percentage}%`;
          }
        }
      }
    }
  };

  // This plugin runs after the chart is drawn or updated.
  // It generates our HTML legend and saves it to state.
  const legendPlugin = {
    id: 'htmlLegend',
    afterUpdate(chart, args, options) {
      const ul = document.createElement('ul');
      chart.options.plugins.legend.labels.generateLabels(chart).forEach(label => {
        const li = document.createElement('li');
        li.style.alignItems = 'center';
        li.style.cursor = 'pointer';
        li.style.display = 'flex';
        li.style.flexDirection = 'row';
        li.style.marginLeft = '10px';

        li.onclick = () => {
          const { type } = chart.config;
          if (type === 'pie' || type === 'doughnut') {
            chart.toggleDataVisibility(label.index);
          } else {
            chart.setDatasetVisibility(label.datasetIndex, !chart.isDatasetVisible(label.datasetIndex));
          }
          chart.update();
        };

        const boxSpan = document.createElement('span');
        boxSpan.style.background = label.fillStyle;
        boxSpan.style.borderColor = label.strokeStyle;
        boxSpan.style.borderWidth = label.lineWidth + 'px';
        boxSpan.style.display = 'inline-block';
        boxSpan.style.height = '20px';
        boxSpan.style.marginRight = '10px';
        boxSpan.style.width = '20px';

        const textContainer = document.createElement('p');
        textContainer.style.color = label.fontColor;
        textContainer.style.margin = 0;
        textContainer.style.padding = 0;
        textContainer.style.textDecoration = label.hidden ? 'line-through' : '';

        const total = chart.getDatasetMeta(0).total;
        const percentage = ((chart.config.data.datasets[0].data[label.index] / total) * 100).toFixed(1);

        const text = document.createTextNode(`${label.text}: ${percentage}%`);
        textContainer.appendChild(text);

        li.appendChild(boxSpan);
        li.appendChild(textContainer);
        ul.appendChild(li);
      });
      setLegendHtml(ul.outerHTML);
    }
  };

  return (
    <div className="desktop-diversification-layout">
      <div className="chart-container">
        <Pie ref={chartRef} data={chartData} options={options} plugins={[legendPlugin]} />
      </div>
      <div className="legend-container" dangerouslySetInnerHTML={{ __html: legendHtml }}></div>
    </div>
  );
}

export default DiversificationPieChart;